import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { TopTimerBar } from './components/TopTimerBar';
export function App() {
  return <div className="min-h-full w-full overflow-x-clip text-plum" data-id="element-0" data-mp="2wj8dbo48im46">
      <MetaPixel data-id="element-1" data-mp="28tw62tsgwo4i" />
      <TopTimerBar data-id="element-2" data-mp="28te0v7ntuzkg" />
      <main data-id="element-3" data-mp="28sutgkvsztko">
        <Hero data-id="element-4" data-mp="28skzynbjv4a8" />
        <Stats data-id="element-5" data-mp="28s2ztflro5x1" />
        <Testimonials data-id="element-6" data-mp="23vkvggucm9l8" />
        <PainPoints data-id="element-7" data-mp="23w4clvc6cty7" />
        <Volumes data-id="element-8" data-mp="23utcq6luo6cd" />
        <Bonuses data-id="element-9" data-mp="23t8hsfvmildz" />
        <Countdown spotsTaken={93} data-id="element-10" data-mp="3ijxpqrsp22kf" />
        <Pricing data-id="element-11" data-mp="3ikqwhsrnks2k" />
        <Steps data-id="element-12" data-mp="3ij61k21ff746" />
        <FAQ data-id="element-13" data-mp="3ijpdn24eb1aa" />
        <ValueStack data-id="element-14" data-mp="3ii4s22026sok" />
      </main>
      <Footer data-id="element-15" data-mp="3ml17xky7saot" />
    </div>;
}